import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, brandColours, fontSize } from '../styles';
import { Container } from './ui';
import SpaCtas from './SpaCtas';
import { slugify } from '../utils';

const StyledSpaCtaGroups = styled.section`
  margin: 40px 0;
`;

const StyledContainer = styled(Container)`
  padding-right: 0;
  padding-left: 0;
`;

const StyledList = styled.ul`
  display: flex;
  gap: 10px;
  padding: 0 20px;
  overflow: auto;
`;

const StyledItem = styled.li`
  flex: 1;
`;

const StyledButton = styled.button`
  padding: 12px;
  width: 100%;
  border: 2px solid ${brandColours.primary};
  white-space: nowrap;

  ${minBreakpointQuery.large`
    padding: 16px;
    ${fontSize(18)};
  `}
`;

const SpaCtaGroups = ({ items }) => (
  <StyledSpaCtaGroups>
    <StyledContainer>
      <StyledList>
        {items.map(({ name }, id) => (
          <StyledItem key={id}>
            <StyledButton
              onClick={() =>
                document
                  .getElementById(slugify(name))
                  .scrollIntoView({ behavior: 'smooth' })
              }
            >
              {name}
            </StyledButton>
          </StyledItem>
        ))}
      </StyledList>
    </StyledContainer>
    {items.map(({ name, spas }, id) => (
      <SpaCtas
        key={id}
        heading={name}
        items={spas}
        affilateName="Jennifer Young"
        isSpaCtaGroups={true}
      />
    ))}
  </StyledSpaCtaGroups>
);

export default SpaCtaGroups;
